<script setup lang="ts">
import { LIcon } from '@wgg.hyve/hyve-ui-library'

type Props = {
  text: string
  icon: string
}
defineProps<Props>()
</script>

<template>
  <div class="list-item-with-icon">
    <LIcon class="list-item-with-icon__icon" :icon="icon" :size="22" />
    <span class="list-item-with-icon__text">{{ text }}</span>
  </div>
</template>

<style scoped lang="scss">
@import 'list-item-with-icon.scss';
</style>
